/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* CreditCategory Page: https://www.creative-tim.com/creditCategory/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";

// reactstrap components
import {
  Alert,
  Button,
  Card,
  CardHeader,
  Col,
  CardFooter,
  Container,
  Row,
} from "reactstrap";
// core components
import CreditCategories from "components/Tables/CreditCategory";
import CreditCategoryModal from "components/Modals/CreditCategory";
import Header from "components/Headers/CreditCategoryHeader";
import CreditCategoryDataService from "../../services/CreditCategoryDataService";

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultModal: false,
      creditCategories: [],
      perPage: 10,
      currentPage: 1,
      currentCreditCategory: {},
    };
    this.CreditCategoryDataService = new CreditCategoryDataService();
  }
  
  toggleModal = (state, formType, creditCategory) => {
    this.setState({
      [state]: !this.state[state],
      formType: formType,
      currentCreditCategory: creditCategory,
    });
  };

  componentDidMount() {
    this.fetchData()
  }
  
  handleSearch = (e) => {
    const keyword = e.target.value;
    this.setState({ 
      currentPage: keyword !== undefined && keyword !== '' ? 1 : this.state.currentPage,
      keyword: keyword,
    }, () => {
      this.fetchData(keyword);
    });
  }
  
  fetchData(keyword) {
    this.CreditCategoryDataService.getList(keyword, this.state.currentPage, this.state.perPage)
      .then(res => this.setState(res));
    setTimeout(() => {
      this.setState({ errorMessage: undefined })
    }, 5000);
  }

  setSuccessMessage = (message) => {
    this.setState({ successMessage: message})
  }

  render() {
    return (
      <>
        <Header />
        {/* Page content */}
        <Container className="mt--7" fluid>
          {/* Table */}
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">Daftar kategori kredit</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        onClick={() => this.toggleModal("formModal", "add")}
                        size="sm"
                      >
                        Tambah baru
                      </Button>
                      <CreditCategoryModal
                        toggleModal={() => this.toggleModal("formModal")}
                        formModal={this.state.formModal}
                        formType={this.state.formType}
                        currentCreditCategory={this.state.currentCreditCategory}
                        setSuccessMessage={this.setSuccessMessage}
                        fetchData={this.fetchData.bind(this)}
                      />
                    </Col>
                    {this.state.successMessage && (
                      <Col xs="12" className="mt-5">
                        <Alert color="success">
                          {this.state.successMessage}
                        </Alert>
                      </Col>
                    )}
                    {this.state.errorMessage && (
                      <Col xs="12" className="mt-5">
                        <Alert color="danger">
                          {this.state.errorMessage}
                        </Alert>
                      </Col>
                    )}
                  </Row>
                </CardHeader>
                <CreditCategories 
                  creditCategories={this.state.creditCategories} 
                  toggleModal={this.toggleModal}
                  formModal={this.state.formModal}
                  formType={this.state.formType}
                  setSuccessMessage={this.setSuccessMessage}
                  fetchData={this.fetchData.bind(this)}
                />
                <CardFooter></CardFooter>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}

export default List;
